import { createContext, useContext, useEffect, useState } from "react";
import { api, setAuthToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("lr_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data.user);
        setOrg(r.data.org);
      })
      .catch(() => setAuthToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    setOrg(r.data.org);
    return r.data;
  };

  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    setAuthToken(r.data.token);
    setUser(r.data.user);
    setOrg(r.data.org);
    return r.data;
  };

  const waitlist = async (payload) => {
    const r = await api.post("/waitlist", payload);
    setAuthToken(r.data.token);
    setUser(r.data.user);
    setOrg(r.data.org);
    return r.data;
  };
  const requestDemo = async (payload) => {
    const r = await api.post("/demo-request", payload);
    setAuthToken(r.data.token);
    setUser(r.data.user);
    setOrg(r.data.org);
    return r.data;
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
    setOrg(null);
  };

  return (
    <AuthCtx.Provider value={{ user, org, loading, login, signup, waitlist, logout, setOrg,requestDemo }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
